var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M 125 244 L 135 255 L 158 268 L 189 275 L 203 275 L 231 269 L 248 261 L 266 247 L 266 244 L 250 228 L 247 228 L 231 240 L 213 247 L 186 248 L 161 240 L 142 227 Z M 238 171 L 238 197 L 265 197 L 265 171 Z M 127 171 L 127 197 L 154 197 L 154 171 Z M 198 17 L 179 23 L 169 40 L 184 71 L 182 101 L 71 101 L 57 111 L 57 170 L 43 171 L 30 184 L 30 212 L 43 225 L 57 226 L 57 305 L 74 323 L 140 323 L 141 390 L 163 399 L 234 323 L 322 322 L 334 309 L 334 226 L 350 225 L 362 213 L 362 184 L 334 170 L 334 114 L 321 101 L 209 100 L 209 68 L 222 53 L 223 38 Z M 84 129 L 307 128 L 308 295 L 222 298 L 169 353 L 168 296 L 85 292 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.8a4f6222f5f2b29232ae5d861061b451.svg";
export { ForwardRef as ReactComponent };